import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";

import { colors } from "Constants";
import imgInvoice from "assets/home/1invoice.png";
import imgPreviews from "assets/home/2previews.png";
import imgDownloads from "assets/home/3downloads.png";

const steps = [
  {
    number: "1",
    title: "Create & send an invoice",
    description: "Quickly create invoices & add photos, videos, and links.",
    image: imgInvoice,
  },
  {
    number: "2",
    title: "Clients see watermarked samples",
    description:
      "The invoice shows auto-watermarked samples, but downloads are locked.",
    image: imgPreviews,
  },
  {
    number: "3",
    title: "Downloads unlock after payment",
    description: "Once payment is received, photos and files unlock instantly.",
    image: imgDownloads,
  },
];

export default function HowItWorksMini() {
  return (
    <Section>
      <Inner>
        <Title>How It Works</Title>
        <Steps>
          {steps.map((step) => (
            <Step key={step.number}>
              <StepNumber>{step.number}</StepNumber>
              <StepTitle>{step.title}</StepTitle>
              <StepImage src={step.image} alt={step.title} />
              <StepDescription>{step.description}</StepDescription>
            </Step>
          ))}
        </Steps>
        <LearnMore to="/how-it-works/">Learn More &rarr;</LearnMore>
      </Inner>
    </Section>
  );
}

const Section = styled.section`
  background: ${colors.offWhite};
  padding: 60px 20px;

  @media (max-width: 650px) {
    padding: 40px 20px;
  }
`;

const Inner = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 36px;
  margin-bottom: 50px;

  @media (max-width: 950px) {
    font-size: 32px;
    margin-bottom: 40px;
  }

  @media (max-width: 640px) {
    font-size: 24px;
    margin-bottom: 30px;
  }
`;

const Steps = styled.div`
  display: flex;
  gap: 40px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 30px;
    max-width: 440px;
    margin: 0 auto;
  }
`;

const Step = styled.div`
  flex: 1;
  text-align: center;
`;

const StepNumber = styled.div`
  font-family: "Merriweather";
  color: ${colors.accentGreen};
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 10px;
  line-height: 1;
`;

const StepTitle = styled.h3`
  font-size: 20px;
  margin-bottom: 16px;

  @media (max-width: 640px) {
    font-size: 18px;
  }
`;

const StepImage = styled.img`
  width: 100%;
  margin-bottom: 12px;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
`;

const StepDescription = styled.p`
  font-size: 17px;
  line-height: 1.5;
  color: #555;
  margin: 0;

  @media (max-width: 640px) {
    font-size: 16px;
  }
`;

const LearnMore = styled(Link)`
  display: inline-block;
  margin-top: 48px;
  color: ${colors.primary};
  font-weight: 600;
  font-size: 21px;
  text-decoration: none;
  transition: transform 250ms;

  &:hover {
    transform: scale(1.04);
  }
`;
